export default {
  "app_label": "reports",
  "model_name": "specialmessage",
  "pagination": true,
  "columns": [
    {
      "name": "pk",
      "label": "ID",
      "help_text": null,
      "hidden": true,
      "identifier": false,
      "data_type": "int",
      "search": false,
      "sort": false
    },
    {
      "name": "excerpt_note",
      "label": "Excerpt note",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": null,
      "search": false,
      "sort": false
    },
    {
      "name": "startdate",
      "label": "Startdate",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "datetime",
      "search": false,
      "sort": true
    },
    {
      "name": "enddate",
      "label": "Enddate",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "datetime",
      "search": false,
      "sort": true
    },
    {
      "name": "status",
      "label": "Status",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "str",
      "search": true,
      "sort": true
    },
    {
      "name": "modified",
      "label": "Modified",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "datetime",
      "search": false,
      "sort": true
    }
  ],
  "filter_by": [
    {
      "label": "Status",
      "name": "status",
      "type": "choice",
      "choices": [
        [
          "a",
          "Active"
        ],
        [
          "i",
          "Inactive"
        ]
      ]
    }
  ],
  "export_import": null
}